import { createAsyncThunk } from "@reduxjs/toolkit";

import { ITileID } from "../../../models/product-compare";

/**
 * Loads a tile ID into the selected tiles list.
 *
 * This thunk is used when initializing selected tiles from URL parameters.
 * It's a simple pass-through thunk that adds the tile ID to the Redux state
 * via the extraReducers handler.
 *
 * Note: This is intentionally async to maintain consistency with other thunks,
 * even though no async work is performed. The state update happens in the
 * fulfilled case handler in the slice's extraReducers.
 */
export const loadSelectedTileID = createAsyncThunk(
    "productcompare/loadSelectedTileID",
    async (tileID: ITileID): Promise<ITileID> => {
        return tileID;
    },
);
